"use client";

import { WORKFLOW_SESSION_SUMMARY_TOAST_DURATION_MS } from "@/lib/modules/calls/workflow/constants";
import type {
  WorkflowSessionSummaryReason,
  WorkflowSessionSummaryStats,
} from "@/lib/modules/calls/workflow/types";
import { toast } from "sonner";

export const showWorkflowSessionSummaryToast = (
  stats: WorkflowSessionSummaryStats,
  reason: WorkflowSessionSummaryReason,
) => {
  const conversionRate =
    stats.callsMade > 0
      ? Math.round((stats.converted / stats.callsMade) * 100)
      : 0;
  const title =
    reason === "queue_exhausted" ? "Queue complete!" : "Workflow ended";

  toast.success(title, {
    id: `workflow-session-summary-${reason}`,
    description: (
      <div className="mt-1 space-y-2 text-sm">
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <span>
            <span className="font-semibold">{stats.callsMade}</span> calls
          </span>
          <span>
            <span className="font-semibold">{stats.tasksCompleted}</span> tasks
          </span>
          <span>
            <span className="font-semibold">{stats.converted}</span> converted
          </span>
          <span>
            <span className="font-semibold">{conversionRate}%</span> conversion
          </span>
          <span>
            <span className="font-semibold">{stats.skipped}</span> skipped
          </span>
        </div>
        <p className="text-muted-foreground">
          {_formatDuration(stats.durationSeconds)} session
        </p>
      </div>
    ),
    duration: WORKFLOW_SESSION_SUMMARY_TOAST_DURATION_MS,
  });
};

const _formatDuration = (durationSeconds: number) => {
  const minutes = Math.floor(durationSeconds / 60);
  const seconds = Math.floor(durationSeconds % 60);

  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }

  return `${seconds}s`;
};
